import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { style: {"border-top":"1px solid var(--ion-color-black)"} }, null, -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { style: {"border-top":"1px solid var(--ion-color-black)"} }, null, -1)

import {
  ProjectClassSummary,
  Colors,
  EnrollmentCardElements,
  CourseReferences,
  EnrollmentCourse,
  EnrollmentCourseProps,
  CustomElement,
  SubscriptionsManager,
  LearningContext,
  LearningSession,
  LearningArea,
  LearningAreasStructures,
  OrdinaryClassSummary,
  TmpList,
  UserSummary,
  SubscriptionsManagerMode,
  CustomSubElements,
  GeneralSubElements,
} from "@/types";
import {
  executeLink,
  getContextAcronym,
  getCurrentElement,
  getCurrentLanguage,
  getCustomMessage,
  getCssColor,
  getIcon,
  getLearningAreasStructures,
  getLearningContexts,
} from "@/utils";
import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonRow,
  IonToolbar,
} from "@ionic/vue";
import { PropType, Ref, ref, watch } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectClassSelector',
  props: {
  title: {
    type: String,
    required: true,
  },
  student_id: {
    type: Number,
    required: true,
  },
  ordinary_class: {
    type: Object as PropType<OrdinaryClassSummary>,
    required: true,
  },
  learning_sessions: Array<LearningSession>,
  project_class: Object as PropType<ProjectClassSummary>,
  learning_session: Object as PropType<LearningSession>,
  section: {
    type: String,
    required: true,
  },
  subscriptions_manager: {
    type: Object as PropType<SubscriptionsManager>,
    required: true,
  },
},
  emits: ["signal_event", "close", "error", "no_courses"],
  async setup(__props, { emit }) {

let __temp: any, __restore: any

const props = __props;

const getCorrectName = (option: LearningArea) => {
  const language = getCurrentLanguage();

  const tmp_learning_area = learning_areas_structures.list.find(
    (a) => a.id == option.id
  );

  return tmp_learning_area != undefined
    ? tmp_learning_area[`${language}_title`]
    : "";
};
const getCreditsList = () => {
  //<!-- TODO (7): Vedere se unire con getSessionList
  let list = "";
  let credits_per_context: TmpList<number>;

  for (const context of learning_contexts) {
    list +=
      "<div><label" +
      (colors.text != undefined
        ? " style='color: " + getCssColor(colors.text) + "'"
        : "") +
      "><b>" +
      context[`${language}_title`] +
      ":</b>";
    if (context.credits != undefined) {
      list +=
        " " +
        (context.credits -
          (props.subscriptions_manager.remaing_credits[context.id] as number)) +
        "/" +
        context.credits +
        "</label>";
    } else {
      list +=
        "</label><ul class='ion-no-margin'" +
        (colors.text != undefined
          ? " style='color: " + getCssColor(colors.text) + "'"
          : "") +
        ">";
      for (const area of learning_areas_structures.list) {
        if (area.credits != undefined) {
          credits_per_context =
            (props.subscriptions_manager.remaing_credits[
              context.id
            ] as TmpList<number>) ?? {};
          list +=
            "<li>" +
            area[`${language}_title`] +
            ": " +
            (area.credits - credits_per_context[area.id]) +
            "/" +
            area.credits +
            "</li>";
        }
      }
      list += "</ul>";
    }
    list += "</div>";
  }

  return list;
};
const getGroupsList = () => {
  let list = "";
  let group_remaining_courses: TmpList<number>;
  let groups: string[];

  for (const context of learning_contexts) {
    list +=
      "<div><label" +
      (colors.text != undefined
        ? " style='color: " + getCssColor(colors.text) + "'"
        : "") +
      "><b>" +
      context[`${language}_title`] +
      ":</b></label><ul class='ion-no-margin'" +
      (colors.text != undefined
        ? " style='color: " + getCssColor(colors.text) + "'"
        : "") +
      ">";
    if (context.credits != undefined) {
      group_remaining_courses =
        props.subscriptions_manager.getGroupRemainingCourses(context.id);
      groups = Object.keys(group_remaining_courses);
      for (const group of groups) {
        list +=
          "<li>" +
          group +
          ": " +
          (store.state.courses_per_group - group_remaining_courses[group]) +
          "/" +
          store.state.courses_per_group +
          "";
      }
    } else {
      for (const area of learning_areas_structures.list) {
        group_remaining_courses =
          props.subscriptions_manager.getGroupRemainingCourses(
            context.id,
            area.id
          );
        groups = Object.keys(group_remaining_courses);
        list +=
          "<li><label>" +
          area[`${language}_title`] +
          ":</label>" +
          "<ul class='ion-no-margin'>";
        for (const group of groups) {
          list +=
            "<li>" +
            group +
            ": " +
            (store.state.courses_per_group - group_remaining_courses[group]) +
            "/" +
            store.state.courses_per_group +
            "";
        }
        list += "</ul></li>";
      }
    }
    list += "</ul></div>";
  }

  return list;
};
const updateLearningAreaPlaceholder = (context_id: string) => {
  placeholder =
    learning_areas_structures.distribution[context_id].length > 0
      ? getCurrentElement("select") +
        (language == "italian" ? " l'" : " the ") +
        learning_area_sentence
      : getCurrentElement("no_learning_areas"); //<!-- TODO (4): sistemare (qui e nelle altre funzioni updateLearningAreaPlaceholder) quando verrà messa la lista parametri a getCurrentElement
};

const store = useStore();
const language = getCurrentLanguage();




const elements: {
  [key: string]: CustomElement;
} = {
  close: {
    id: "close",
    type: "icon",
    linkType: "event",
    content: {
      event: "close",
      icon: getIcon("close"),
    },
  },
};
const first_row: CustomElement[] = [
  {
    id: "group",
    type: "string",
    content: getCurrentElement("group"),
  },
  {
    id: "credits",
    type: "string",
    content: getCurrentElement("credits"),
  },
  {
    id: "course",
    type: "string",
    content: getCurrentElement("course"),
  },
];
const colors: Colors<GeneralSubElements> = {
  text: {
    name: "primary",
    type: "var",
  },
};
const column_sizes = store.state.sections_use ? ["2", "2", "5", "2", "1"] : ["2", "2", "6", "2"];
const project_class_card =
  props.project_class != undefined
    ? props.project_class.toCard(undefined, props.section, false, true)
    : undefined;
const learning_sessions: LearningSession[] =
  props.learning_sessions ??
  (props.project_class != undefined
    ? (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
        "/v1/learning_sessions?year_of=" +
          props.project_class.learning_session.id,
        (response) =>
          response.data.data.map((a: any) => new LearningSession(a)),
        () => []
      ))),
  __temp = await __temp,
  __restore(),
  __temp
)
    : []);
const origin: {
  references: CourseReferences | undefined;
  course: EnrollmentCardElements | undefined;
  learning_context: LearningContext | undefined;
  learning_area: LearningArea | undefined;
} = {
  references: undefined,
  course: undefined,
  learning_context: undefined,
  learning_area: undefined,
};
const student = new UserSummary({
  id: props.student_id,
  user: "student",
});
const learning_area_sentence = getCurrentElement("learning_area");
const trigger = ref(0);
const tmp_courses: EnrollmentCourse[] = [];

let actual_learning_session: LearningSession,
  learning_contexts: LearningContext[],
  learning_areas_structures: LearningAreasStructures,
  selected_context: Ref<string>,
  selected_area: Ref<string>;
let credits_list = "";
let groups_list = "";
let confirmed_courses = false;
let placeholder = getCurrentElement("no_learning_areas");

if (props.project_class != undefined || props.learning_session != undefined) {
  actual_learning_session =
    props.project_class != undefined
      ? props.project_class.learning_session
      : (props.learning_session as LearningSession);
  learning_contexts = (
  ([__temp,__restore] = _withAsyncContext(() => getLearningContexts(
    student,
    "" + actual_learning_session.id
  ))),
  __temp = await __temp,
  __restore(),
  __temp
); //<!-- TODO (6): sistemare id (es. tutti stringa)
  learning_areas_structures = (
  ([__temp,__restore] = _withAsyncContext(() => getLearningAreasStructures(
    learning_contexts,
    "" + actual_learning_session.id
  ))),
  __temp = await __temp,
  __restore(),
  __temp
);
  selected_context = ref(
    learning_contexts.length > 0 ? learning_contexts[0].id : ""
  );
  selected_area = ref(
    learning_areas_structures.distribution[selected_context.value].length > 0
      ? learning_areas_structures.distribution[selected_context.value][0].id
      : ""
  );

  if (project_class_card != undefined) {
    project_class_card.colors = colors as Colors<CustomSubElements>;
    for (const element of project_class_card.content as CustomElement[]) {
      element.colors = colors as Colors<CustomSubElements>;
    }
  }
  if (
    learning_contexts.length > 0 &&
    learning_areas_structures.list.length > 0
  ) {
    if (store.state.sections_use) {
      first_row.push({
        id: "section",
        type: "string",
        content: getCurrentElement("section"),
      });
    }
    first_row.push({
      id: "move_student",
      type: "string",
      content: "",
    });

    (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
      "/v2/courses?student_id=" +
        props.student_id +
        "&session_id=" +
        actual_learning_session.id,
      (response) => {
        let tmp_course: EnrollmentCourse;
        for (const course_props of response.data
          .data as EnrollmentCourseProps[]) {
          course_props.section = "A"; //<!-- TODO (4): gestire sezioni
          tmp_course = new EnrollmentCourse(course_props);
          if (tmp_course.final_confirmation == null) {
            tmp_courses.push(tmp_course);
          } else {
            confirmed_courses = true;
          }
        }
      },
      () => []
    ))),
  await __temp,
  __restore()
);

    if (tmp_courses.length > 0) {
      (
  ([__temp,__restore] = _withAsyncContext(() => props.subscriptions_manager.loadParameters(
        student,
        props.ordinary_class,
        learning_contexts,
        learning_areas_structures.list,
        learning_sessions,
        tmp_courses,
        "" + actual_learning_session.id
      ))),
  await __temp,
  __restore()
);
      props.subscriptions_manager.showCourses(
        selected_context.value,
        selected_area.value,
        props.project_class != undefined
          ? ["" + props.project_class.course_id]
          : undefined
      );
      if (props.project_class != undefined) {
        origin.references = props.subscriptions_manager.getCourseReferences(
          "" + props.project_class.course_id
        );
        origin.course =
          origin.references != undefined &&
          typeof origin.references.indexes.index == "number"
            ? props.subscriptions_manager.all_courses[
                origin.references.learning_context_id
              ][origin.references.learning_area_id][
                origin.references.indexes.index
              ]
            : undefined;
        origin.learning_context = learning_contexts.find(
          (a) => a.id == origin.references?.learning_context_id
        );
        origin.learning_area = learning_areas_structures.list.find(
          (a) => a.id == origin.references?.learning_area_id
        );
      }

      credits_list = getCreditsList();
      groups_list = getGroupsList();

      updateLearningAreaPlaceholder(selected_context.value);
      watch(selected_area, async (new_area) => {
        props.subscriptions_manager.showCourses(
          selected_context.value,
          new_area,
          props.project_class != undefined
            ? ["" + props.project_class.course_id]
            : undefined
        );
        trigger.value++;
      });
    } else {
      store.state.event = {
        event: "no_courses",
        data: {
          message: confirmed_courses
            ? getCurrentElement("all_project_classes_confirmed")
            : getCurrentElement("no_courses"),
        },
      };
      emit("signal_event");
    }
  }
  watch(selected_context, async (new_context) => {
    updateLearningAreaPlaceholder(new_context);
    selected_area.value =
      learning_areas_structures.distribution[new_context].length > 0
        ? learning_areas_structures.distribution[new_context][0].id
        : "";
    if (tmp_courses.length > 0) {
      props.subscriptions_manager.showCourses(
        new_context,
        selected_area.value,
        props.project_class != undefined
          ? ["" + props.project_class.course_id]
          : undefined
      );
    }
    trigger.value++;
  });
} else {
  store.state.event = {
    event: "error",
  };
  emit("signal_event");
}

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_custom_select = _resolveComponent("custom-select")!
  const _component_ionic_table = _resolveComponent("ionic-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), { class: "ion-text-center ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: _unref(getCustomMessage)('title', __props.title, 'title')
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol), { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.close,
                          onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonGrid), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    (_unref(project_class_card) != undefined)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_ionic_element, {
                            element: 
                _unref(getCustomMessage)(
                  'actual_course',
                  _unref(getCurrentElement)('actual_course') + ':',
                  'title',
                  colors
                )
              
                          }, null, 8, ["element"]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_ionic_element, {
                              element: 
                  _unref(getCustomMessage)(
                    'learning_context_area_title',
                    _unref(getCurrentElement)('learning_context') +
                      ' - ' +
                      _unref(getCurrentElement)('learning_area'),
                    'title',
                    colors
                  )
                
                            }, null, 8, ["element"]),
                            _createVNode(_component_ionic_element, {
                              element: 
                  _unref(getCustomMessage)(
                    'learning_context_area',
                    ': ' +
                      (origin.learning_context != undefined
                        ? origin.learning_context[`${_unref(language)}_title`]
                        : '') +
                      ' - ' +
                      (origin.learning_area != undefined
                        ? origin.learning_area[`${_unref(language)}_title`]
                        : ''),
                    'string',
                    colors
                  )
                
                            }, null, 8, ["element"])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project_class_card).content, (element) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: element.id
                            }, [
                              _createVNode(_component_ionic_element, { element: element }, null, 8, ["element"])
                            ]))
                          }), 128)),
                          _createElementVNode("div", null, [
                            _createVNode(_component_ionic_element, {
                              element: 
                  _unref(getCustomMessage)(
                    'credits',
                    _unref(getCurrentElement)('credits'),
                    'title',
                    colors
                  )
                
                            }, null, 8, ["element"]),
                            _createVNode(_component_ionic_element, {
                              element: 
                  _unref(getCustomMessage)(
                    'credits',
                    ': ' +
                      (origin.course != undefined ? origin.course.credits : ''),
                    'string',
                    colors
                  )
                
                            }, null, 8, ["element"])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), { class: "" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_component_ionic_element, {
                      element: 
              _unref(getCustomMessage)(
                'constraints',
                _unref(getCurrentElement)('constraints').toUpperCase(),
                'title',
                colors
              )
            
                    }, null, 8, ["element"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ionic_element, {
                      element: 
              _unref(getCustomMessage)(
                'student_credits',
                _unref(getCurrentElement)('credits'),
                'title',
                colors
              )
            
                    }, null, 8, ["element"]),
                    _createElementVNode("div", { innerHTML: _unref(credits_list) }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ionic_element, {
                      element: 
              _unref(getCustomMessage)(
                'student_groups',
                _unref(getCurrentElement)('groups_courses'),
                'title',
                colors
              )
            
                    }, null, 8, ["element"]),
                    _createElementVNode("div", { innerHTML: _unref(groups_list) }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_ionic_element, {
                      element: 
              _unref(getCustomMessage)(
                'choice',
                _unref(getCurrentElement)('project_class_movement_choice'),
                'title',
                colors,
                {
                  label: {
                    'ion-padding-top': true,
                    'ion-padding-start': true,
                  },
                }
              )
            
                    }, null, 8, ["element"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { size: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_custom_select, {
                      selected_option: _unref(selected_context),
                      "onUpdate:selected_option": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selected_context) ? (selected_context).value = $event : selected_context = $event)),
                      list: _unref(learning_contexts),
                      label: _unref(getCurrentElement)('learning_context') + ':',
                      aria_label: _unref(getCurrentElement)('learning_context'),
                      placeholder: _unref(getCurrentElement)('learning_context_choice'),
                      getCompleteName: _unref(getContextAcronym)
                    }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder", "getCompleteName"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCol), { size: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_custom_select, {
                      selected_option: _unref(selected_area),
                      "onUpdate:selected_option": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selected_area) ? (selected_area).value = $event : selected_area = $event)),
                      list: _unref(learning_areas_structures).distribution[_unref(selected_context)],
                      label: _unref(learning_area_sentence) + ':',
                      aria_label: _unref(learning_area_sentence),
                      placeholder: _unref(placeholder),
                      getCompleteName: getCorrectName
                    }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_unref(IonCol), { key: trigger.value }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_openBlock(), _createBlock(_component_ionic_table, {
                        key: trigger.value,
                        emptiness_message: 
                _unref(getCustomMessage)(
                  'emptiness_message',
                  _unref(getCurrentElement)('no_courses'),
                  'string',
                  colors,
                  {
                    label: {
                      align_text_middle: true,
                    },
                  }
                )
              ,
                        data: props.subscriptions_manager.courses,
                        first_row: first_row,
                        sizes: _unref(column_sizes),
                        onSignal_event: _cache[3] || (_cache[3] = ($event: any) => {
                if (
                  __props.subscriptions_manager.mode == _unref(SubscriptionsManagerMode).MOVE &&
                  __props.project_class != undefined
                ) {
                  _unref(store).state.event.data.from = {
                    course_id: __props.project_class.course_id,
                    session_id: __props.project_class.learning_session.id,
                  };
                }
                _ctx.$emit('signal_event');
              })
                      }, null, 8, ["emptiness_message", "data", "sizes"]))
                    ])
                  ]),
                  _: 1
                }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})